var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.items,"loading":_vm.loading,"label":_vm.label,"rules":_vm.rules},model:{value:(_vm.motivoLead),callback:function ($$v) {_vm.motivoLead=$$v},expression:"motivoLead"}})}
var staticRenderFns = []

export { render, staticRenderFns }